import { render, staticRenderFns } from "./ActivityStatusChip.vue?vue&type=template&id=1c0c64aa&scoped=true&"
import script from "./ActivityStatusChip.vue?vue&type=script&lang=js&"
export * from "./ActivityStatusChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0c64aa",
  null
  
)

export default component.exports